import { FeatureFlags } from '~commonInfra/featureFlags/FeatureFlags';
import { ContentRelayUtils } from '~src/contentRelay/utils/ContentRelayUtils';

import { selectCatalogingOnSiteEnabled } from '../../../../catalog/selectors/CatalogSelectors';
import { Messages } from '../../../../codegen/Localize';
import { setDescriptionAction } from '../../../actions/SetDescriptionAction';
import { ISetDescriptionAction } from '../../../models/actionNames';
import { IContentInfo } from '../../../models/IContentInfo';
import { EntityActionNames, IEntityAction } from './IEntityAction';

export const SetDescriptionAction: IEntityAction<IContentInfo<'database'> | IContentInfo<'table'>, ISetDescriptionAction> = {
  name: EntityActionNames.SetDescription,
  translateName: Messages.editDescription1,
  isVisible: (_, state) => selectCatalogingOnSiteEnabled(state),
  isClickable: (availableActions: ISetDescriptionAction) => !!(availableActions && availableActions.setDescription),
  createReduxAction: (items) => {
    if (!items || items.length === 0 || items.length > 1) {
      throw new Error('setDescription was called without exactly one item');
    }

    return setDescriptionAction(items[0]);
  }
};

export const SetPublishedConnectionDescriptionAction: IEntityAction<IContentInfo<'virtualConnection'>, ISetDescriptionAction> = {
  name: EntityActionNames.SetDescription,
  translateName: Messages.editDescription1,
  isVisible: () => FeatureFlags.publishedConnectionContentManagementEnabled,
  isClickable: (availableActions: ISetDescriptionAction) => !!(availableActions && availableActions.setDescription),
  createReduxAction: (items) => {
    if (!items || items.length === 0 || items.length > 1) {
      throw new Error('setDescription was called without exactly one item');
    }

    return setDescriptionAction(items[0]);
  }
};

export const SetPublishedConnectionTableDescriptionAction: IEntityAction<IContentInfo<'virtualConnectionTable'>, ISetDescriptionAction> = {
  name: EntityActionNames.SetDescription,
  translateName: Messages.editDescription1,
  isVisible: () => FeatureFlags.publishedConnectionContentManagementEnabled,
  isClickable: (availableActions: ISetDescriptionAction) => !!(availableActions && availableActions.setDescription),
  createReduxAction: (items) => {
    if (!items || items.length === 0 || items.length > 1) {
      throw new Error('setDescription was called without exactly one item');
    }

    return setDescriptionAction(items[0]);
  }
};

/**
 * "Edit description" on a single Content Relay plan. Reuses the shared description editor/saga (same
 * as workbooks/data sources) rather than a bespoke dialog; the save routes to `setRelayPlanDescription`
 * in SetDescriptionSaga. Plans have no per-item action-permission model, so it is always clickable.
 */
export const SetContentRelayPlanDescriptionAction: IEntityAction<IContentInfo<'contentRelayPlan'>, {}> = {
  name: EntityActionNames.SetDescription,
  translateName: Messages.editDescription1,
  isVisible: (targetItems) => ContentRelayUtils.isContentRelayEnabled() && targetItems.length === 1,
  isClickable: () => true,
  createReduxAction: (items) => {
    if (!items || items.length !== 1) {
      throw new Error('setDescription was called without exactly one item');
    }

    return setDescriptionAction(items[0]);
  }
};
